import assetPath from '/app/packages/lebenslauf/articles/src/assets/erfolgreiches-motivationsschreiben-5.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')